module.exports = __webpack_public_path__ + "assets/fonts/DIN-Medium.1bbe3460.otf";